import axios from "axios";

const storefrontProxyUrl = process.env.REACT_APP_STOREFRONT_PROXY_URL;

export async function getAllBrands() {
    try {
        const response = await axios.get(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/brands`, {
            params: {
                include_fields: 'name',
                sort: 'name',
                direction: 'asc',
                limit: 200
            },
            headers: {
                'Accept': 'application/json'
            }
        });
        return response.data.data;
    } catch (error) {
        console.error('Failed to fetch brands:', error.message);
        return [];
    }
}